import React, { CSSProperties, createElement } from 'react';
import { ReactQuestionFactory, SurveyQuestionImage } from 'survey-react-ui';

// Workaround for a SurveyJS bug: it renders YouTube embeds without allowfullscreen, so the expand button fails.
export class SurveyQuestionImageWithFullscreen extends SurveyQuestionImage {
  protected renderElement() {
    const { question } = this;

    if (question.renderedMode !== 'youtube' || !question.imageLink || question.contentNotLoaded) {
      return super.renderElement();
    }

    const style = {
      objectFit: question.imageFit as CSSProperties['objectFit'],
      width: question.renderedStyleWidth,
      height: question.renderedStyleHeight
    };

    return (
      <div className={question.cssClasses.root}>
        <iframe
          className={question.getImageCss()}
          src={question.locImageLink.renderedHtml}
          width={question.renderedWidth}
          height={question.renderedHeight}
          style={style}
          title={question.renderedAltText}
          allow="fullscreen"
          allowFullScreen
        />
      </div>
    );
  }
}

const CustomizeSurveyImage = () => {
  ReactQuestionFactory.Instance.registerQuestion('image', (props) => {
    return createElement(SurveyQuestionImageWithFullscreen, props);
  });
};

export default CustomizeSurveyImage;
